module.exports = __webpack_public_path__ + "5087a581c908076086ce81b15fc961ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/g/g04.jpg
// module id = 566
// module chunks = 0